import { useState, useCallback, useMemo } from 'react'
import { api } from '../services/api'

// FAR-44: get/post/put/del must be STABLE across renders. They used to be new
// arrow functions every render, so a screen doing
//   useEffect(() => { get('/items') }, [get])
// re-ran its effect on every render: the request set loading -> re-render ->
// new `get` -> effect again -> another request. Item Data sent ~1,000 GET
// /items in a few minutes and never settled ("spinning and stuck"); Item Run
// Rates had the same loop. `call` is already stable (useCallback, no deps), so
// memoising the wrappers on it makes them stable too.
export function useApi() {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const call = useCallback(async (method, path, body) => {
    setLoading(true)
    setError(null)
    try {
      const data = await api[method](path, body)
      return data
    } catch (err) {
      setError(err.message)
      throw err
    } finally {
      setLoading(false)
    }
  }, [])

  const methods = useMemo(() => ({
    get: (path) => call('get', path),
    post: (path, body) => call('post', path, body),
    put: (path, body) => call('put', path, body),
    del: (path) => call('delete', path),
  }), [call])

  return { loading, error, ...methods }
}
